<mat-toolbar color="secondary" class="header-toolbar">
  <!-- <section>
    <div class="example-flex-container">
      <button mat-icon-button color="basic" id="menu-toggle" aria-label="Icon button with a menu icon" id="expanded"
        (click)="toggleDrawer()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </section> -->
  <section>
    <div class="company-logo" *ngIf="(logo | async)">
      <img src="{{(logo | async)?.url}}" class="logo" alt="logo">
    </div>
  </section>
  <section class="info">
    <div class="info">
      <!-- <span>Operation </span> -->
      <mat-form-field appearance="outline" class="operations-selector">
        <mat-select [value]="selectedOperation$ | async" [compareWith]="compareOperations"
          (selectionChange)="handleChangeOperation($event)" placeholder="Operation">
          <mat-option [value]="{id: '', name: 'all'}">All</mat-option>
          <mat-option *ngFor="let op of operations$ | async" [value]="op">{{op.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-icon-button color="basic" aria-label="notifications" class="header-icon-btn">
        <img src="./assets/icons/bell.svg" (click)="toggleNotificationView()" class="header-icon" alt="notifications">
      </button>
      
      <button mat-icon-button color="basic" aria-label="messages" class="header-icon-btn">
        <img src="./assets/icons/annotation.svg" class="header-icon" alt="messages">
      </button>
      
      <button mat-icon-button color="basic" aria-label="info" class="header-icon-btn">
        <svg class="info-icon" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2420_6560)">
            <path d="M8.29872 5.85246H9.76921V7.36066H8.29872V5.85246ZM9.03396 13.3934C9.43835 13.3934 9.76921 13.0541 9.76921 12.6393V9.62295C9.76921 9.2082 9.43835 8.86886 9.03396 8.86886C8.62958 8.86886 8.29872 9.2082 8.29872 9.62295V12.6393C8.29872 13.0541 8.62958 13.3934 9.03396 13.3934ZM9.03396 2.08197C4.97543 2.08197 1.68155 5.46033 1.68155 9.62295C1.68155 13.7856 4.97543 17.1639 9.03396 17.1639C13.0925 17.1639 16.3864 13.7856 16.3864 9.62295C16.3864 5.46033 13.0925 2.08197 9.03396 2.08197ZM9.03396 15.6557C5.79155 15.6557 3.15203 12.9485 3.15203 9.62295C3.15203 6.29738 5.79155 3.59017 9.03396 3.59017C12.2764 3.59017 14.9159 6.29738 14.9159 9.62295C14.9159 12.9485 12.2764 15.6557 9.03396 15.6557Z" fill="#A3AED0"/>
          </g>
          <defs>
            <clipPath id="clip0_2420_6560">
              <rect width="17.6458" height="18.0984" fill="white" transform="translate(0.21106 0.573761)"/>
            </clipPath>
          </defs>
        </svg>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="User profile menu" class="user-avatar-btn">
        <img [src]="(orgUserPhotoUrl$ | async) || 'assets/icons/user.svg'" class="user-avatar" alt="User Profile">
      </button>

      <div>
        <div *ngIf="showNotifications" class="notification-panel">
          <div *ngFor="let notification of firebaseNotifications$ | async; let i = index">
            <div class="notification-body" (click)="onClickNotification(notification)">
              <div class="notification-content">
                <img *ngIf="notification.updatedNotificationType === 'INCIDENT'" class="image"
                  src="./assets/icons/incident.svg" alt="delay">&nbsp;
                <img *ngIf="notification.updatedNotificationType !== 'INCIDENT'" class="image"
                  src="./assets/icons/complete.svg" alt="delay">&nbsp;
                <div class="notification-details">
                  <div class="heading">{{notification.message}}</div>
                  <div class="sub-heading">{{notification.title}}</div>
                  <div class="time-diff">{{notification.timeDiff}}</div>
                </div>
              </div>
              <div class="line"></div>
            </div>
          </div>
          <div class="see-more">
            <button class="property" mat-stroked-button color="primary" (click)="seeMore()">See more</button>
          </div>
        </div>
      </div>

      <mat-menu #menu="matMenu" class="user-profile-menu">
        <div class="user-profile-header">
          <div class="user-avatar-large">
            <img [src]="(orgUserPhotoUrl$ | async) || 'assets/icons/user.svg'" alt="User Profile">
          </div>
          <div class="user-details">
            <p class="user-name">{{ (user$ | async)?.firstName }} {{ (user$ | async)?.lastName }}</p>
            <p class="user-role">{{ (organization$ | async)?.orgName || 'N/A' }}</p>
          </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>
  </section>
</mat-toolbar>

<!-- <mat-form-field appearance="outline" class="operations-selector">
  <mat-label>Favorite food</mat-label>
  <mat-select>
    <mat-option value="volvo">Volvo</mat-option>
    <mat-option value="saab">Saab</mat-option>
    <mat-option value="mercedes">Mercedes</mat-option>
    <mat-option value="audi">Audi</mat-option>
  </mat-select>
</mat-form-field> -->